import React from 'react';
import PropTypes from 'prop-types';

import formikPropTypes from '@zr/components/Fields/Formik/formikPropTypes';

import EducationFields from './EducationFields';

const getLegendText = (entryIndex, totalEntries) => (
  `Education (Entry ${entryIndex} of ${totalEntries})`
);

export function IncompleteEducationFieldset({
  disabled, entryIndex, formikProps, totalEntries, enableRichText,
}) {
  return (
    <fieldset disabled={disabled}>
      <legend className="title">{getLegendText(entryIndex, totalEntries)}</legend>
      <EducationFields formikProps={formikProps} enableRichText={enableRichText} />
    </fieldset>
  );
}

IncompleteEducationFieldset.propTypes = {
  entryIndex: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  formikProps: formikPropTypes.isRequired,
  totalEntries: PropTypes.number.isRequired,
  enableRichText: PropTypes.bool,
};

IncompleteEducationFieldset.defaultProps = {
  disabled: false,
  enableRichText: false,
};

export default IncompleteEducationFieldset;
